import React from 'react';

export const Header = ({ data }) => {
  const renderParagraph = (paragraphs) => {
    return paragraphs.map((paragraph, i) => {
      return <section key={`paragraph-${i}`} className='paragraph'>{paragraph}</section>;
    });
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>{data ? data.title : 'Loading...'}</h1>
                <h2>
                  {data ? renderParagraph(data.paragraph) : 'loading...'}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
